<template>
  <img class="background-img" :class="{'background-transition': transition}" :src="backgrounds[index]"/>
</template>

<script>
export default {
  name: 'AnimatedBackground',
  data: () => ({
    animation: null,
    transition: false,
    index: 0,
    interval: 8000,
    backgrounds: [
      './background/1.jpg',
    ]
  }),
  methods: {
    animate () {
      if (this.backgrounds.length <= 1) {
        return;
      }
      this.animation = setInterval(() => {
        this.transition = true
        setTimeout(() => {
          this.index = (this.index + 1) % this.backgrounds.length
          this.transition = false
        }, 600);
      }, this.interval);
    }
  },
  created () {
    this.animate()
  },
  beforeDestroy () {
    clearInterval(this.animation)
  }
}
</script>

<style scoped>
.background-img {
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  background-size: cover;
  background-position: center;
  box-shadow: 0 0 0 500px rgba(45, 45, 48, 0.3) inset;
}

.background-transition {
  opacity: 0;
}
</style>
